<script setup lang="ts">
useHead({
  title: 'Craft'
})

const shareId = useState('shareId')

const router = useRouter()

onMounted(() => {
  if(shareId.value) {
    router.push('/patientDesign/new/patient')
  } else {
    router.replace('/patientDesign')
  }
})

onActivated(() => {
  if(shareId.value && shareId.value !== '' && shareId.value !== 'undefined' && shareId.value?.trim() !== '') {
    router.push('/patientDesign/new/patient')
  } else {
    router.replace('/patientDesign')
  }
})
</script>

<template>
  <div class="w-full h-full flex justify-center items-center">
    正在加载中，请稍等！
  </div>
</template>

<style scoped>

</style>
